import React from "react";
import { FormattedMessage } from "react-intl";
import IntlDateTime from "~/src/shared/components/IntlDateTime";
import * as palette from "@govlaunch/palette";

interface ICurrentBillingTrialPeriodProps {
  trialPeriod: number;
  subscribedAt: any;
}

export default function CurrentBillingTrialPeriod({ trialPeriod, subscribedAt }: ICurrentBillingTrialPeriodProps) {
  return (
    <>
      <div
        css={{
          fontSize: 16,
          fontWeight: 600,
          color: "#949195",
        }}
      >
        <FormattedMessage defaultMessage="Trial Period" id="CEvh7B" />
      </div>

      <div
        css={{
          display: "grid",
          gridRowGap: 8,
        }}
      >
        <strong
          css={{
            fontSize: 16,
            fontWeight: 600,
            color: palette.text,
          }}
        >
          <FormattedMessage
            defaultMessage="{count, plural, one {# day} other {# days}}, started on"
            id="RMd73v"
            values={{ count: trialPeriod }}
          />{" "}
          <IntlDateTime value={subscribedAt} />
        </strong>
      </div>
    </>
  );
}
